import { __ } from "@wordpress/i18n";
import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
	URLInput,
} from "@wordpress/block-editor";
import { PanelBody, ToggleControl, TextControl } from "@wordpress/components";
import { Fragment } from "@wordpress/element";

export default function Edit({ attributes, setAttributes }) {
	const { url, opensInNewTab } = attributes;

	return (
		<Fragment>
			<InspectorControls>
				<PanelBody title={__("Link Settings", "dapoobembe")}>
					<URLInput
						label={__("Select or enter URL", "dapoobembe")}
						value={url}
						onChange={(value) => setAttributes({ url: value })}
					/>
					<ToggleControl
						label={__("Open in new tab", "dapoobembe")}
						checked={opensInNewTab}
						onChange={(value) => setAttributes({ opensInNewTab: value })}
					/>
				</PanelBody>
			</InspectorControls>
			<div {...useBlockProps()}>
				<InnerBlocks />
			</div>
		</Fragment>
	);
}
